import { useEffect } from 'react';
import './MultigroupSelect.scss';
import { PredictionDataType, SatelliteGroupsType } from '../types';
import CustomToolTip from '../../../CommonComponents/CustomToolTip';
import { DEFAULT_ORBIT_COLOR } from '../../../../utils/constants';

interface Props {
    groups?: SatelliteGroupsType[];
    selected_group?: SatelliteGroupsType | null;
    satellites?: { label: string; value: any }[];
    prediction_data?: PredictionDataType | null;
    selected_satellite?: { label: string; value: any } | null;
    set_selected_group: (value: SatelliteGroupsType | null) => void;
    set_selected_satellite: (value: { label: string; value: any } | null) => void;
    disabled?: boolean;
}

const MultigroupSelect = ({
    groups,
    selected_group,
    satellites,
    selected_satellite,
    prediction_data,
    set_selected_group,
    set_selected_satellite,
    disabled
}: Props) => {

    useEffect(() => {
        const clickOutSide = (e: any) => {
            const dropdown1 = document.getElementById('dropdown__1');
            const dropdown2 = document.getElementById('dropdown__2');
            if (dropdown1 && !dropdown1.contains(e.target)) {
                dropdown1.classList.remove('active');
            }
            if (dropdown2 && !dropdown2.contains(e.target)) {
                dropdown2.classList.remove('active');
            }
        }
        document.addEventListener('click', clickOutSide);
        return () => {
            document.removeEventListener('click', clickOutSide);
        }
    }, [])

    const handleDropdownClick = (dropdownRef: string) => {
        const element = document.getElementById(dropdownRef);
        if (!element) return
        else if (!element.classList.contains('active')) {
            element.classList.add('active');
            if (dropdownRef === 'dropdown__1') {
                const secondElement = document.getElementById('dropdown__2');
                if (secondElement) secondElement.classList.remove('active');
            } else if (dropdownRef === 'dropdown__2') {
                const firstElement = document.getElementById('dropdown__1');
                if (firstElement) firstElement.classList.remove('active');
            }
        } else {
            element.classList.remove('active');
        }
    };

    const getGroupColor = (group: SatelliteGroupsType | null) => {
        if (!group) return '';
        const color = (group?.value?.color !== '' && !group?.value?.color.includes('#')) ? JSON.parse(group?.value?.color) : DEFAULT_ORBIT_COLOR;
        return `rgba(${color})`;
    }

    /**** AT-11431 Fix ****/
   // if ((groups && groups?.length === 1) && (satellites && satellites?.length === 1)) return null;

    return (
        <div className={`multigroup__selection__container ${disabled && 'disabled'} `}>
            <div id='dropdown__1' className='group__select__container' onClick={() => {
                if (groups && groups?.length === 1) return
                handleDropdownClick('dropdown__1')
            }}>
                <div className='group__select__header'>
                    <div className='group__select__header__text__container'>
                        <div className='color__container' style={{ backgroundColor: getGroupColor(selected_group as SatelliteGroupsType | null) }} />
                        <span className='group__select__header__text'>
                            <CustomToolTip title={selected_group?.label ?? ''} placement='top-start'>
                                {selected_group?.label}
                            </CustomToolTip>
                        </span>
                    </div>
                    {groups && groups?.length > 1 &&
                        <div className='group__select__header__icon'>
                            <i className='fe fe-chevron-down' />
                        </div>
                    }
                </div>
                <div className='group__select__body'>
                    {groups && groups?.map(group => (
                        <div key={group.value.groupId}
                            className={`group__select__body__item ${group?.value?.groupId === selected_group?.value.groupId && 'active'}`}
                            onClick={() => {
                                set_selected_group(group);
                                set_selected_satellite(group.value.satellites[0]);
                            }}
                        >
                            <div className='body__text__container'>
                                <div className='color__container' style={{ backgroundColor: getGroupColor(group) }} />
                                <span className='body__text'>
                                    <CustomToolTip title={group.label ?? ''} placement='top-start'>{group.label}</CustomToolTip>
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div id='dropdown__2' className='group__select__container'
                onClick={() => {
                    if (satellites && satellites?.length === 1) return
                    handleDropdownClick('dropdown__2')
                }}>
                <div className='group__select__header'>
                    <div className='group__select__header__text__container'>
                        <span className='group__select__header__text'>
                            <CustomToolTip title={selected_satellite?.label ?? ''} placement='top-start'>{selected_satellite?.label}</CustomToolTip>
                        </span>
                    </div>
                    {satellites && satellites?.length > 1 &&
                        <div className='group__select__header__icon'>
                            <i className='fe fe-chevron-down' />
                        </div>
                    }
                    {satellites && satellites?.length === 1 && prediction_data?.[satellites?.[0].value.satId]?.state === 'loading' &&
                        <div className='header__icon__container'>
                            <div className='prediction__loader small' />
                        </div>
                    }
                    {satellites && satellites?.length === 1 && prediction_data?.[satellites?.[0].value.satId]?.state === 'success' &&
                        <div className='header__icon__container'>
                            <div className='prediction__badge'>
                                <span className='badge__text'>PS</span>
                            </div>
                        </div>
                    }
                </div>
                {satellites && satellites?.length > 1 &&
                    <div className='group__select__body'>
                        {satellites?.map(satellite => (
                            <div key={satellite.value.satId}
                                className={`group__select__body__item ${satellite?.value?.satId === selected_satellite?.value.satId && 'active'}`}
                                onClick={() => {
                                    set_selected_satellite(satellite);
                                }}
                            >
                                <div className='body__text__container w-80'>
                                    <span className='body__text'>
                                        <CustomToolTip title={satellite.label ?? ''} placement='top-start'>{satellite.label}</CustomToolTip>
                                    </span>
                                </div>
                                <div className='body__icon__container'>
                                    {prediction_data?.[satellite.value.satId]?.state === 'loading' &&
                                        <div className='prediction__loader' />
                                    }
                                    {prediction_data?.[satellite.value.satId]?.state === 'success' &&
                                        <div className='prediction__badge'>
                                            <span className='badge__text'>PS</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
};

export default MultigroupSelect;